import { defineMessages } from 'react-intl-next';

export default defineMessages({
	button: {
		id: 'fabric.editor.ai.commandPalette.promptBuilder.buttons.submit',
		defaultMessage: 'Create',
		description: 'Label for the Submit button in the command palette',
	},
});
